import { render } from "./Language.vue?vue&type=template&id=11e637e7&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"

import "./Language.vue?vue&type=style&index=0&id=11e637e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e637e7"]])

export default __exports__